import { RootState } from "redux/rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.mentalCheckDetails.loading;
export const selectErrorMessage = (state: RootState) =>
  state.mentalCheckDetails.error;
export const mentalCheckDetailsDataResponse = (state: RootState) =>
  state.mentalCheckDetails.mentalCheckDetailsResponse;
